import React from 'react';
import PropTypes from 'prop-types';

import NumericInput from '@common/components/numericInput';
import { useTranslation } from '@common/hooks/translation';
import { useSelector } from 'react-redux';
import Config from '@app/dev/config/main';

const DepositAmountForm = ({ amount, onChange, errorText }) => {
  const t = useTranslation();
  const user = useSelector((state) => state.user);
  const { loggedIn, loggedInByRFID } = user;
  const userLoggedin = loggedInByRFID || loggedIn;

  if (!userLoggedin && Config.main.depositWithoutLogin.disabled) {
    const { text } = Config.main.depositWithoutLogin;
    return (
      <div className="popup-main-content">
        <p className="deposite-sign-in">
          {t(text)}
        </p>
      </div>
    );
  }

  return (
    <div className="popup-main-content">
      <p className="text-center">{t('Please input deposit amount')}</p>
      <div className="input-wrapper">
        <div className="input-row">
          <NumericInput
            className="numeric-input"
            onChange={onChange}
            value={amount}
          />
        </div>
        {errorText && (
          <div className="error-row">
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">
              {Array.isArray(errorText) ? t(...errorText) : t(errorText)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

DepositAmountForm.propTypes = {
  amount: PropTypes.string,
  onChange: PropTypes.func,
  errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default DepositAmountForm;
